'use strict';

var tgApi = require('../../api/tg-api.js');
var logger = require('../../utils/logger.js');

var FluxDispatcher 	= require('../dispatchers/flux-dispatcher.js');
var Constants 		= require('../constants/course-search-constants.js');

var ActionTypes = Constants.ActionTypes;

function log(source, actionType, data) {
	logger.debug({
		actionCreator: 'Course Search',
		message: 'Create ' + source + ' action',
		action: actionType,
		data: data
	});
}

function createServerAction(actionType, data) {
	log('server', actionType, data);
	FluxDispatcher.dispatchServerAction({
		type: actionType,
		data: data
	});
}

function createViewAction(actionType, data) {
	log('view', actionType, data);
	FluxDispatcher.dispatchViewAction({
		type: actionType,
		data: data
	});
}

function loadDataError() {
	createServerAction(ActionTypes.COURSE_SEARCH_LOAD_DATA_ERROR);
}

function loadDataSuccess(data) {
	if (data) {
		createServerAction(ActionTypes.COURSE_SEARCH_LOAD_DATA_SUCCESS, data);
	} else {
		loadDataError();
	}
}

function loadData(filterState) {
	createServerAction(ActionTypes.COURSE_SEARCH_LOAD_DATA);
	tgApi.getCourseData(loadDataSuccess, loadDataError, null, filterState);
}

module.exports = {
	updateFilters: function (filterState) {
		createViewAction(ActionTypes.COURSE_SEARCH_UPDATE_FILTERS);
		loadData(filterState);
	},

	submitForm: function (searchResultsUrl) {
		window.location = searchResultsUrl;
	},

	clearFilters: function (defaultResultsUrl) {
		window.location = defaultResultsUrl;
	}
};